<template>
    <div class="card-body border-top">
        <div class="row">
            <div :class="selectedMethod.fields.fields.length % 2 === 0 || idx < selectedMethod.fields.fields.length -1 ? 'col-12 col-md-6' : 'col-12'" v-for="(field, idx) in selectedMethod.fields.fields">
                <div class="form-group">
                    <label class="d-block">{{ field.label }}</label>
                    <component :is="field.component" :field="field" v-model="formData[field.name]" @input="buildPaymentMethodData" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import InputText from "./Dynamic/InputText";
    import InputEmailAddress from "./Dynamic/InputEmailAddress";
    import InputSelect from "./Dynamic/InputSelect";
    import InputTel from "./Dynamic/InputTel";

    export default {
        name: "FieldsDynamic",
        data() {
            return {
                formData: {}
            }
        },
        methods: {
            buildPaymentMethodData () {
                console.log(this.formData);
                let valid = true;
                let data = {};
                for (let i in this.selectedMethod.fields.fields) {
                    let field = this.selectedMethod.fields.fields[i];

                    let value = this.formData[field.name];

                    if (!value) {
                        valid = false;
                    }

                    data[field.name] = value;
                }

                this.$store.commit('setPaymentMethodData', {
                    valid : valid,
                    data: data
                });
            }
        },
        computed: mapState({
            selectedMethod: state => state.payment.selectedMethod
        }),
        mounted() {
            this.$store.commit('setPaymentMethodData', {
                valid : false,
                data: {}
            });
            this.buildPaymentMethodData()
        },
        components: {
            InputText,
            InputEmailAddress,
            InputSelect,
            InputTel
        },
    }
</script>

<style scoped>

</style>
